var _style, _path, _rect, _rect2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmergencyLighting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "16.4px",
    height: "16.4px",
    viewBox: "0 0 16.4 16.4",
    style: {
      enableBackground: "new 0 0 16.4 16.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Emergency Lighting") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.2,8.2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 0.2,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 8.2514 -3.4607)",
    className: "st1",
    width: 0.7,
    height: 16.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 0.2,
    transform: "matrix(0.7337 -0.6795 0.6795 0.7337 -3.3885 7.8363)",
    className: "st1",
    width: 0.7,
    height: 16.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 8.2,
    cy: 8.2,
    r: 1.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyLighting);
export default __webpack_public_path__ + "static/media/EmergencyLighting.70cb2b792a6da2d867873afeeecb7e9a.svg";
export { ForwardRef as ReactComponent };